module.exports = __webpack_public_path__ + "assets/small-logo.a94c6909.svg";